const currentVersion = process.env.REACT_APP_LATEST_TERMS_VERSION || '';

export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const validateTermsLatestVersion = (termsVersion: string): boolean => {
  if (!DATE_REGEX.test(termsVersion) || !DATE_REGEX.test(currentVersion)) {
    console.error('Failed to parse terms version:', {
      termsVersion,
      currentVersion,
    });

    return false;
  }

  return termsVersion === currentVersion;
};
